import useForgotPassword from "@/api/mutation/useForgotPasswordEmailSend";
import InputEmail from "@/components/common/InputEmail";
import { Button } from "@/components/ui/button";
import { forgotPasswordSchema } from "@backend/src/schemas/authSchema";
import { isAxiosError } from "axios";
import { useFormik } from "formik";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toFormikValidationSchema } from "zod-formik-adapter";
import ErrorMessage from "@/components/common/ErrorMessage";
import EmailSend from "../../../assets/svg/EmailSendSuccess.svg";
import { z } from "zod";
import { toast } from "react-toastify";
import NewLogoTitle from "@/assets/svg/NewLogoTitle.svg";
import BackgroundImage from "@/components/layout/BackgroundImage";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";

function ForgotPassword() {
  const forgotPasswordMutation = useForgotPassword();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik<z.infer<typeof forgotPasswordSchema>>({
    initialValues: {
      email: "",
    },
    validationSchema: toFormikValidationSchema(forgotPasswordSchema),
    onSubmit: (values, helper) => {
      setIsLoading(true);
      forgotPasswordMutation.mutate(values, {
        onSuccess(data) {
          toast.success(data.data.message);
          setIsLoading(false);
          setIsSubmitted(true);
        },
        onError(error) {
          if (isAxiosError(error)) {
            setIsLoading(false);
            if (
              error.response?.status === 400 &&
              error.response.data?.errors &&
              Array.isArray(error.response?.data.errors)
            ) {
              error.response.data.errors.forEach((item) => {
                helper.setFieldError(item.path[0], item.message);
              });
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(
                t(errorKeyFormate(error.response?.data.message + "")),
                errorConfig
              );
            }
          }
        },
      });
    },
  });
  const { t } = useTranslation();
  return (
    <div className="flex flex-col px-2 items-center min-h-screen py-6 justify-center bg-secondary-950">
      <BackgroundImage />
      <div className="absolute bg-primary-500/20 rounded-br-3xl px-40 rounded-bl-3xl mb-5 h-24 w-auto top-0  left-1/2 -translate-x-1/2 flex justify-center items-center">
        <img src={NewLogoTitle} className="h-10" />
      </div>
      <div className="w-[min(460px,100%)] space-y-4 px-1 py-4 overflow-hidden bg-white shadow-md sm:max-w-lg sm:rounded-lg">
        <div className="px-2">
          <h3 className="text-2xl text-center font-semibold text-secondary-950">
            {!isSubmitted ? "Forgot Password?" : ""}
          </h3>
        </div>
        {!isSubmitted ? (
          <div className="px-4 text-[#666666] text-lg text-center flex justify-center break-words whitespace-pre-wrap">
            {t(
              "Enter Your email below to get the reset link for your password!"
            )}
          </div>
        ) : (
          ""
        )}
        {isSubmitted ? (
          <div className="flex flex-col justify-center items-center">
            <div className="h-16 w-16 rounded-full bg-success bg-opacity-60 flex justify-center items-center">
              <img src={EmailSend} className="h-11" />
            </div>
            <div className="text-center mt-4">
              <p className="text-secondary-950 text-2xl font-semibold">
                {t("Password Reset Request Successful!")} <br />
                <p
                  className="text-lg mt-4 mx-2 text-[#666666] text-center flex justify-center break-words font-normal"
                  style={{ wordBreak: "break-word" }}
                >
                  {t(
                    "Please check your email for further instructions on resetting your password."
                  )}
                </p>
              </p>
            </div>
            <div className="w-full p-3 mt-3">
              <Button
                type="submit"
                variant={"primary"}
                className="w-full text-white"
                onClick={() => navigate("/login")}
              >
                {t("back")}
              </Button>
            </div>
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit} className="px-4 flex flex-col ">
            <div className="mt-1 ">
              {/* <label htmlFor="email" className={labelStyle}>
                Email
              </label> */}
              <InputEmail
                name="email"
                id="email"
                className="rounded-xl"
                value={formik.values.email}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              <ErrorMessage>
                {formik.touched.email && formik.errors.email}
              </ErrorMessage>
            </div>
            <div className="w-full flex justify-end items-center my-3">
              <NavLink className="font-bold underline text-xs" to="/signup">
                {t("Click here to Sign Up")}
              </NavLink>
            </div>
            <div className="flex flex-col justify-center mt-1.5 ">
              <Button
                type="submit"
                variant={"primary"}
                className="w-full text-white"
                isLoading={isLoading}
                disabled={isLoading}
              >
                {t("submit")}
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
